import { DefaultLayout } from "./layouts";

import MeetingNotes from "./views/MeetingNotes/MeetingNotes";
import Login from "./views/Login";
import LoginLayout from "./layouts/Login";
import ViewMeetingNote from "./views/MeetingNotes/ViewMeetingNote";

export default [
  {
    path: "/",
    exact: true,
    layout: LoginLayout,
    component:  Login
  },
  
  {
    path: "/meetingNote/:id",
    exact: true,
    layout: DefaultLayout,
    component: ViewMeetingNote
  },
  {
    path: "/meetingNotes",
    exact: true,
    layout: DefaultLayout,
    component: MeetingNotes
  },
];
